<template>
  <div class="setVipTag">
    <pageTitle pageTitle="观众等级标签">
      <p class="switch__box">
        <vh-switch
          :value="switchStatus"
          active-color="#FB3A32"
          inactive-color="#CECECE"
          :inactive-value="0"
          :active-value="1"
          @change="changeVipTagSwitch"
        ></vh-switch>
        <span class="title_text">
          {{
            switchStatus ? '已开启' : '开启后'
          }}，通过接口传参后账号下所有的直播间聊天区展示观众身份等级标签
        </span>
      </p>
    </pageTitle>
    <p class="title_note">
      注意：开启后在嵌入页地址中传入观众等级字段（member_level）即可，详细信息
      <a href="https://saas-doc.vhall.com/opendocs/show/1763" target="_blank" class="link">
        对接文档
      </a>
    </p>
    <div class="setVipTag-container" :class="[{ inactive: !status }]">
      <div class="setVipTag-form">
        <div class="form-item">
          <div class="form-item__hd">展示效果</div>
          <div class="form-item__bd">
            <vh-radio-group v-model="type">
              <vh-radio label="default">默认效果</vh-radio>
              <vh-radio label="custom">自定义效果</vh-radio>
            </vh-radio-group>
          </div>
        </div>
        <vh-table :data="dataList" size="small" :border="true">
          <vh-table-column label="字段" width="100" prop="name"></vh-table-column>
          <vh-table-column label="图片（建议尺寸68*24，jpg/jpeg/png/bmp，10KB以内）">
            <template slot-scope="scope">
              <vh-image
                v-if="type === 'default'"
                class="level-image"
                :src="scope.row.icon"
                fit="contain"
                :preview-src-list="[scope.row.icon]"
              ></vh-image>
              <template v-else>
                <template v-if="scope.row.customIcon">
                  <vh-image
                    class="level-image"
                    :src="scope.row.customIcon"
                    fit="contain"
                    :preview-src-list="[scope.row.customIcon]"
                  ></vh-image>
                  <vh-button class="btn-remove" type="text" @click="handleRemove(scope.row.level)">
                    删除
                  </vh-button>
                </template>
                <vh-button
                  class="btn-upload"
                  v-else
                  type="text"
                  @click="handleUpload(scope.row.level)"
                >
                  上传图片
                </vh-button>
              </template>
            </template>
          </vh-table-column>
        </vh-table>
        <div class="form-item">
          <div class="form-item__bd" style="padding-left: 24px">
            <vh-button size="medium" type="primary" round v-preventReClick @click="handleSave">
              保存
            </vh-button>
          </div>
        </div>
      </div>
      <div class="preview-box">
        <img class="preview_vip" src="@/common/images/plan-function/vip_preview.png" alt="" />
      </div>
    </div>

    <!-- 上传剪裁组件：所有的自定义图片，上传剪裁共用一个 -->
    <UploadCropper
      style="opacity: 0"
      ref="vipTagUploadCropper"
      :imageUrl.sync="currentImgUrl"
      accept="image/jpeg,image/jpg,image/png,image/bmp"
      :limitSize="10"
      :cropRatio="68 / 24"
      @onUploadComplete="uploadComplete"
    />
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import to from 'await-to-js';
  import { safeJsonParse } from '@/utils/utils';
  import { UploadCropper } from '@vhcl/upload-cropper';

  export default {
    name: 'OfficialAccAuth',
    components: {
      PageTitle,
      UploadCropper
    },
    data() {
      return {
        originConfig: null, // 初始化获取到的最原始的配置信息
        switchStatus: 0, // 开关组件的开关状态：1.开启，0.关闭
        status: 0, // 接口返回的开关状态：1.开启，0.关闭
        type: 'default', // 展示效果: default 默认； custom 自定义
        dataList: new Array(21).fill(1).map((value, index) => {
          const num = value + index;
          return {
            level: num,
            name: `level ${num}`,
            customIcon: '',
            /* prettier-ignore */
            icon: `https://${ process.env.VUE_APP_STATIC_URL }/common-static/images/member-level/default/vip${num}.png`
          };
        }),

        // 自定义效果，上传时当前操作的图片
        currentLevel: '',
        currentImgUrl: ''
      };
    },

    methods: {
      // 获取观众用户等级的设置信息
      async getMemberLevelConfig() {
        const params = { type: 'member_level' };
        const [err, res] = await to(this.$fetch('getGeneralConfig', params));
        if (err || !res || res.code != 200) {
          this.$message.error(err?.msg || res?.msg || '请求失败');
          return;
        }
        // content结构(如果从来没设置过，content是空的):
        // {
        //   status: 1, //状态：1.开启，0.关闭
        //   type: 'custom', //显示效果类型：custom:自定义效果，default:默认效果
        //   custom_list: [
        //     {
        //       // 等级列表
        //       level: '1', // 等级
        //       icon: '1.jpg' // 等级对应的icon
        //     },
        //     {
        //       level: '2',
        //       icon: '2.jpg'
        //     }
        //   ]
        // };
        const content = safeJsonParse(res.data?.content);
        this.originConfig = content;
        this.switchStatus = this.status = content?.status || 0;
        this.type = content?.type || 'default';
        for (const item of content?.custom_list || []) {
          this.dataList[item.level - 1].customIcon = item.icon;
        }
      },
      /**
       * 开关变化时，执行保存操作
       * @param value
       */
      async changeVipTagSwitch(value) {
        this.doSubmit({ status: value });
      },
      /**
       * 保存设置
       * @param options 变化的参数
       */
      async doSubmit(options) {
        // 接口只能保存全量数据，所以需要合并参数
        const mergedOptions = Object.assign({}, this.originConfig, options);
        for (const item of mergedOptions?.custom_list || []) {
          item.icon = this.$parseURL(item.icon).path; // 转换图片路径
        }
        const params = {
          type: 'member_level',
          content: JSON.stringify(mergedOptions)
        };
        const [err, res] = await to(this.$fetch('saveGeneralConfig', params));
        if (err || !res || res.code != 200) {
          this.$message.error(err?.msg || res?.msg || '请求失败');
          return;
        }
        if (Object.hasOwnProperty.call(mergedOptions, 'status')) {
          this.switchStatus = mergedOptions.status; // 设置成功, 更新开关组件状态
        }
        // 获取配置信息更新本地数据
        this.getMemberLevelConfig();
        this.$message.success('设置成功');
      },
      // 点击 上传
      handleUpload(level) {
        this.currentLevel = level;
        this.$refs['vipTagUploadCropper'].$el.querySelector('input[name="resfile"]').click();
      },
      // 点击 删除
      handleRemove(level) {
        const currentItem = this.dataList.find(item => item.level === level);
        if (currentItem) {
          currentItem.customIcon = '';
        }
      },
      // 上传完成
      uploadComplete(cbData) {
        if (cbData) {
          const currentItem = this.dataList.find(item => item.level === this.currentLevel);
          if (currentItem) {
            // console.log('cbData.domain_url:', cbData);
            currentItem.customIcon = cbData.domain_url;
          }
        }
      },
      // 保存
      async handleSave() {
        // type 展示效果, 只有两种: default 默认； custom 自定义
        const options = {
          type: this.type
        };
        if (this.type === 'custom') {
          // 如果是自定义效果，拿到自定义的图片等信息
          const custom_list = [];
          for (const item of this.dataList) {
            if (item.customIcon) {
              custom_list.push({
                level: item.level,
                icon: item.customIcon
              });
            }
          }
          options.custom_list = custom_list;
        }
        // 执行提交动作
        this.doSubmit(options);
      }
    },
    created() {
      this.getMemberLevelConfig();
    }
  };
</script>

<style lang="less" scoped>
  .setVipTag {
    font-size: 14px;
    .title_text {
      color: #999;
      vertical-align: middle;
    }
    .link {
      color: #3562fa;
    }
    .title_note {
      color: #999;
    }
  }
  .setVipTag-container {
    display: flex;
    margin-top: 24px;
    background-color: #fff;
    position: relative;

    &.inactive {
      &::after {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: '';
        background-color: rgba(255, 255, 255, 0.4);
        z-index: 10;
      }
    }

    .setVipTag-form {
      width: 510px;
      margin-right: 64px;
      padding-left: 24px;

      ::v-deep .vh-table--enable-row-hover .vh-table__body tr:hover > td {
        background-color: #fff;
      }

      ::v-deep .vh-table .cell {
        line-height: 1;
        min-height: 24px;
        display: flex;
        align-items: center;
      }
      .form-item {
        display: flex;
        flex-direction: row;
        padding: 16px 0;

        &.border {
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;
          border-right: 1px solid #ccc;
        }

        &__hd {
          width: 100px;
        }
        &__bd {
          flex: 1;
        }
      }

      .level-image {
        max-width: 160px;
        height: 24px;
        vertical-align: middle;

        ::v-deep .vh-image__inner {
          height: 100%;
          width: auto;
        }
      }
      .btn-remove {
        margin-left: 16px;
      }
      .btn-remove,
      .btn-upload {
        vertical-align: middle;
      }
    }

    .preview-box {
      // 预览图
      .preview_vip {
        margin: 20px 0;
        width: 300px;
        object-fit: contain;
      }
    }
  }
</style>
